(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
class CartNote extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('change', debounce((event) => {
			const body = JSON.stringify({ note: event.target.value });
			fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
		}, 300))
	}
}

customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-finder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-finder]');
    if (!root) return;
    var grid = root.querySelector('[data-finder-grid]');
    var cells = Array.prototype.slice.call(grid.querySelectorAll('.finder-cell'));
    var countEl = root.querySelector('[data-finder-count]');
    var emptyEl = root.querySelector('[data-finder-empty]');
    var clearBtns = root.querySelectorAll('[data-finder-clear]');

    var active = { family: [], reach: [], voltage: [] };

    // Price slider
    var pf = root.querySelector('[data-price-facet]');
    var minR = pf && pf.querySelector('[data-price-min]');
    var maxR = pf && pf.querySelector('[data-price-max]');
    var fill = pf && pf.querySelector('[data-price-fill]');
    var outMin = pf && pf.querySelector('[data-price-out-min]');
    var outMax = pf && pf.querySelector('[data-price-out-max]');
    var ceil = maxR ? (parseInt(maxR.max, 10) || 0) : 0;

    function priceActive() { return minR && (parseInt(minR.value, 10) > 0 || parseInt(maxR.value, 10) < ceil); }
    function anyActive() { return active.family.length || active.reach.length || active.voltage.length || priceActive(); }

    function cellMatches(c) {
      var facets = ['family', 'reach', 'voltage'];
      for (var i = 0; i < facets.length; i++) {
        var f = facets[i];
        if (active[f].length) {
          var vals = (c.getAttribute('data-' + f) || '').split(' ').filter(Boolean);
          var hit = false;
          for (var j = 0; j < vals.length; j++) { if (active[f].indexOf(vals[j]) !== -1) { hit = true; break; } }
          if (!hit) return false;
        }
      }
      if (minR) {
        var p = parseInt(c.getAttribute('data-price'), 10);
        if (p < parseInt(minR.value, 10) * 100 || p > parseInt(maxR.value, 10) * 100) return false;
      }
      return true;
    }

    function apply() {
      var shown = 0;
      cells.forEach(function (c) { var m = cellMatches(c); c.hidden = !m; if (m) shown++; });
      if (countEl) countEl.textContent = shown;
      if (emptyEl) emptyEl.hidden = shown !== 0;
      clearBtns.forEach(function (b) { b.hidden = !anyActive(); });
    }

    root.querySelectorAll('.finder__opt').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var f = btn.getAttribute('data-facet'), v = btn.getAttribute('data-value');
        var arr = active[f], i = arr.indexOf(v);
        if (i === -1) { arr.push(v); btn.classList.add('is-active'); btn.setAttribute('aria-pressed', 'true'); }
        else { arr.splice(i, 1); btn.classList.remove('is-active'); btn.setAttribute('aria-pressed', 'false'); }
        apply();
      });
    });

    if (minR && maxR) {
      function money(d) { return '$' + d.toLocaleString(); }
      function priceApply() {
        var lo = parseInt(minR.value, 10), hi = parseInt(maxR.value, 10);
        if (lo > hi) { if (document.activeElement === minR) { hi = lo; maxR.value = hi; } else { lo = hi; minR.value = lo; } }
        if (fill) { fill.style.left = (lo / ceil * 100) + '%'; fill.style.width = ((hi - lo) / ceil * 100) + '%'; }
        if (outMin) outMin.textContent = money(lo);
        if (outMax) outMax.textContent = money(hi);
        apply();
      }
      minR.addEventListener('input', priceApply);
      maxR.addEventListener('input', priceApply);
    }

    clearBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        active = { family: [], reach: [], voltage: [] };
        root.querySelectorAll('.finder__opt.is-active').forEach(function (o) { o.classList.remove('is-active'); o.setAttribute('aria-pressed', 'false'); });
        if (minR) { minR.value = 0; maxR.value = ceil; if (fill) { fill.style.left = '0%'; fill.style.width = '100%'; } if (outMin) outMin.textContent = '$0'; if (outMax) outMax.textContent = '$' + ceil; }
        apply();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resources-library"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-rl-controls]');
    if (!root) return;
    var cards = [].slice.call(document.querySelectorAll('[data-rl-card]'));
    var blocks = [].slice.call(document.querySelectorAll('[data-rl-block]'));
    var sections = [].slice.call(document.querySelectorAll('[data-rl-section]'));
    var search = document.querySelector('[data-rl-search]');
    var kindBtns = [].slice.call(document.querySelectorAll('[data-rl-kind]'));
    var doctypeSel = document.querySelector('[data-rl-doctype]');
    var audSel = document.querySelector('[data-rl-aud]');
    var visEl = document.querySelector('[data-rl-visible]');
    var emptyEl = document.querySelector('[data-rl-empty]');
    var state = { kind: 'all', q: '', doctype: '', aud: '' };

    function title(s) { return s.replace(/_/g, ' ').replace(/\b\w/g, function (m) { return m.toUpperCase(); }); }
    var dts = {}, auds = {};
    cards.forEach(function (c) {
      var dt = c.getAttribute('data-doctype'); if (dt) dts[dt] = 1;
      (c.getAttribute('data-aud') || '').split(/\s+/).forEach(function (a) { if (a) auds[a] = 1; });
    });
    Object.keys(dts).sort().forEach(function (dt) { var o = document.createElement('option'); o.value = dt; o.textContent = title(dt); doctypeSel.appendChild(o); });
    Object.keys(auds).sort().forEach(function (a) { var o = document.createElement('option'); o.value = a; o.textContent = title(a); audSel.appendChild(o); });

    function apply() {
      var n = 0;
      cards.forEach(function (c) {
        var ok = true;
        if (state.kind !== 'all' && c.getAttribute('data-kind') !== state.kind) ok = false;
        if (ok && state.doctype && c.getAttribute('data-doctype') !== state.doctype) ok = false;
        if (ok && state.aud && (' ' + (c.getAttribute('data-aud') || '') + ' ').indexOf(' ' + state.aud + ' ') < 0) ok = false;
        if (ok && state.q && (c.getAttribute('data-title') || '').indexOf(state.q) < 0) ok = false;
        c.hidden = !ok; if (ok) n++;
      });
      blocks.forEach(function (b) { b.hidden = !b.querySelector('[data-rl-card]:not([hidden])'); });
      sections.forEach(function (sec) { sec.hidden = !sec.querySelector('[data-rl-card]:not([hidden])'); });
      if (visEl) visEl.textContent = n;
      if (emptyEl) emptyEl.hidden = n !== 0;
    }
    if (search) search.addEventListener('input', function () { state.q = this.value.trim().toLowerCase(); apply(); });
    kindBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        kindBtns.forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-pressed', 'false'); });
        b.classList.add('is-active'); b.setAttribute('aria-pressed', 'true');
        state.kind = b.getAttribute('data-rl-kind'); apply();
      });
    });
    if (doctypeSel) doctypeSel.addEventListener('change', function () { state.doctype = this.value; apply(); });
    if (audSel) audSel.addEventListener('change', function () { state.aud = this.value; apply(); });
    document.querySelectorAll('[data-rl-clear]').forEach(function (b) {
      b.addEventListener('click', function () {
        state = { kind: 'all', q: '', doctype: '', aud: '' };
        if (search) search.value = ''; if (doctypeSel) doctypeSel.value = ''; if (audSel) audSel.value = '';
        kindBtns.forEach(function (x) { var on = x.getAttribute('data-rl-kind') === 'all'; x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        apply();
      });
    });
    apply();

    /* ---- inline video lightbox (progressive enhancement) ---- */
    var dlg = document.querySelector('[data-rl-player]');
    var mount = document.querySelector('[data-rl-player-mount]');
    var titleEl = document.querySelector('[data-rl-player-title]');
    var canModal = dlg && typeof dlg.showModal === 'function';
    function openPlayer(embed, vtitle) {
      if (!canModal) return false;
      var sep = embed.indexOf('?') > -1 ? '&' : '?';
      var src = embed + sep + 'autoplay=1&rel=0&modestbranding=1&playsinline=1';
      var f = document.createElement('iframe');
      f.setAttribute('src', src);
      f.setAttribute('title', vtitle || 'Video player');
      f.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; web-share');
      f.setAttribute('allowfullscreen', '');
      mount.innerHTML = ''; mount.appendChild(f);
      if (titleEl) titleEl.textContent = vtitle || '';
      dlg.showModal();
      return true;
    }
    function closePlayer() { if (dlg && dlg.open) dlg.close(); }
    if (canModal) {
      document.querySelectorAll('[data-rl-play]').forEach(function (el) {
        el.addEventListener('click', function (e) {
          var embed = el.getAttribute('data-embed');
          if (!embed) return;
          if (openPlayer(embed, el.getAttribute('data-vtitle'))) e.preventDefault();
        });
      });
      var closeBtn = document.querySelector('[data-rl-player-close]');
      if (closeBtn) closeBtn.addEventListener('click', closePlayer);
      dlg.addEventListener('click', function (e) { if (e.target === dlg) closePlayer(); });
      dlg.addEventListener('close', function () { mount.innerHTML = ''; });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
